import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { ComboModel } from './model/combo.model';
import { ComboService } from './combo.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { PermissionService } from 'src/app/auth/permission.service';
import { AppConstants } from 'src/app/common/app.constants';
import { SaleItemService } from '../sale-item/sale-item.service';
import { StorageService } from 'src/app/common/services/storage.service';

@Component({
  selector: 'app-combo',
  templateUrl: './combo.component.html',
  styleUrls: ['./combo.component.scss'],
  standalone: false
})
export class ComboComponent {

  comboList: ComboModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [];
  displayedColumns = ['code', 'name', 'display_name', 'value_name', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: ComboModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<ComboModel>(true, []);
  dataSource = new MatTableDataSource(this.comboList);
  IsDownloading: boolean = false;
  context: any = [];
  isFilterReady = false;
  permission: any;
  saleItems: any;

  constructor(private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private comboService: ComboService,
    public permissionService: PermissionService,
    private router: Router, private stateManagerService: StateManagerService,
    private saleItemService: SaleItemService,
    private storageService: StorageService,
  ) {
    this.permission = permissionService.getPagePermission("combo");
    this.comboList = [];
  }

  ngOnInit(): void {
    this.storageService.clearSessionByName(AppConstants.SESSION_VAR_COMBO_SALE_ITEMS);
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });

    this.generateFilterList();
    const storedSaleItems = sessionStorage.getItem(AppConstants.SESSION_VAR_COMBO_SALE_ITEMS);
    if (storedSaleItems == null || storedSaleItems == undefined) {
      this.getComboSaleItems();
    }
    // this.loadData();
  }

  generateFilterList() {
    this.filter = [
      {
        title: "Code",
        column: "combo_option.code",
      },
      {
        title: "Name",
        column: "combo_option.name",
      },
      {
        title: "Display Name",
        column: "combo_option.display_name",
      },
      {
        title: "Values",
        column: "combo_option.name",
      },
    ];
    this.isFilterReady = true;
  }

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData();
  }

  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('combo_option.name', 'asc');
      this.loadData();
    }

  }

  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });

    let sortId = column;
    if (sortId && sortId.startsWith("combo_option.")) {
      sortId = sortId.replace("combo_option.", "");
    }

    this.sort.sort({
      id: sortId,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }

  loadData() {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.comboService.getComboList(requestData).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.comboList = response.data.combo;
          this.pagingData.length = response.data.total_count;
          this.dataSource = new MatTableDataSource(this.comboList);
          if (this.pagingData.length === 0) {
            const snackBarData: SnackBarData = {
              message: 'No data found. Please remove or change the filter if any.',
              title: 'No Data!!!',
              type: 'warn'
            };
            this.snackBarService.openSnackBar(snackBarData);
            this.selectedItem = undefined;
          } else {
            this.stateManagerService.setState(this.constructor.name, requestData);
          }

          this.isLoading = false;
        } else {
          this.isLoading = false;
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        this.isLoading = false;
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }
  /**
       * Builds the request data to be send to API
       * @returns Request Data
       */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "is_system")
    ) {
      defFilter.push({
        column: "is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }
  /**
  * Create sort order
  * @returns sort criteria
  */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }
  /**
   * On menuInfo selected
   * @param menuInfo 
   */
  onRowSelected(menuInfo: ComboModel): void {
    this.selectedItem = menuInfo;
    this.showSummaryPanel = true;
  }
  onDelete(comboInfo: ComboModel): void {
    const comboId = comboInfo.id;
    const message = `Are you sure, you want to delete ` + (comboInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult === true) {
        this.comboService.deleteCombo(comboId!).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Success!!!',
                type: 'success'
              }
              this.snackBarService.openSnackBar(snackBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to delete. Connection to the server failed.',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  onEdit(comboInfo: ComboModel): void {
    this.router.navigate(['product/combo-edit', comboInfo.id]);
  }

  onDuplicate(comboInfo: ComboModel): void {
    if (comboInfo.id === undefined) {
      // Optionally show an error or return early
      return;
    }
    this.comboService.getComboById(comboInfo.id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          const comboItem = response.data.combo;
          const comboOptionValues = response.data.combo_option_value;
          const newCombo = {
            ...comboItem,
            id: 0, // treat as new
            code: '', // let user enter a new code
            name: comboItem.name,
            description: comboItem.description ? comboItem.description : '',
            display_name: comboItem.display_name ? comboItem.display_name : '',
            comboOptionValues: comboOptionValues
              ? comboOptionValues.map((v: any) => ({ ...v, id: 0 }))
              : []
          };

          this.router.navigate(['product/combo-edit', 0], { state: { comboData: newCombo } });
        }
      },
      error: () => {
        // Optionally handle error
      }
    });
  }

  onePageEvent(event: any): void {
    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;
    this.loadData();
  }

  addClicked(): void {
    this.router.navigate(['product/combo-edit', 0]);
  }

  onFilterApplied(event: any): void {
    this.searchColumFilter = event;
    this.pagingData.pageIndex = 0;
    this.loadData();
  }

  sortData(event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: "combo_option." + sd.active, order: sd.direction });
    this.loadData();
  }

  exportClicked(): void {
    if (this.pagingData.length === 0) {
      let snackBarData: SnackBarData = {
        message: 'No data found to export. Please remove or change the filter if any.',
        title: 'No Data!!!',
        type: 'warn'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.comboService['downloadExcel'](requestData)
      .subscribe({
        next: (blob: Blob | MediaSource) => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'combo_list.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: (_error: any) => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }

  getComboSaleItems() {
    const requestData: RequestData =
    {
      search: {
        filters: {
          advSearch:
            [
              {
                column: "sale_item.item_type",
                operator: "!=",
                value: 3
              },
              {
                column: "item_classes.is_deleted",
                operator: "=",
                value: 0
              },
              {
                column: "sale_item.is_valid",
                operator: "=",
                value: 1
              }
            ],
          scope: {
            limit: 5000,
            offset: 0
          }
        },
        sort: [

        ]
      }
    };


    this.saleItemService.getList(requestData).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.saleItems = response.data.items;
          // Sort sale items by name in ascending order
          this.saleItems.sort((a: any, b: any) => a.name.localeCompare(b.name));
          if (this.saleItems !== null && this.saleItems !== undefined) {
            sessionStorage.setItem(AppConstants.SESSION_VAR_COMBO_SALE_ITEMS, JSON.stringify(this.saleItems));
          }
          // console.log('Sale items loaded successfully:', this.saleItems.length);
        } else {
          // console.error('Failed to load sale items:', response.message);
        }
      },
      error: (error: any) => {
        // console.error('API error when loading sale items:', error);
      }
    });
  }
}